(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["kc-additional-details"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.kc-add-details a.hover_rotate').forEach(function(btn) {
    btn.addEventListener('mouseenter', function() {
      btn.setAttribute('data-interacted', '');
    }, { once: true });
  });
  } catch(e) { console.error(e); }
})();

})();
